import React from 'react'
import Bus from '../../bus'

import BetManager from '../../managers/bet'
import {
  ODDS_HIGHLIGHTED_STATUS,
  useBetsOddsHighlight
} from './odds.highlighter'

import { extractBetsFromBetDtoOutcomes, getIntUID, logger } from '../../utils'

import { BetslipContext, useBetslipState } from './betslip.context'
import { betslipReducer } from './betslip.reducer'

import { BETSLIP_STATE_UPDATE } from '../../actions'
import { isEmpty } from 'lodash'

export const EditBetslipProvider = (props) => {
  const { children, id, bet } = props

  const { settings } = useBetslipState()

  const betslipState = createEditBetslipState({
    id,
    bet,
    settings
  })

  /*
    Updating edit betslip provider settings
    every time main betslip settings changed
  */
  React.useEffect(() => {
    logger.debug(
      `[betslip:${betslipState.id}]`,
      'updating settings from main betslip',
      settings
    )

    Bus.emit(`betslip:${betslipState.id}`, {
      type: BETSLIP_STATE_UPDATE,
      payload: {
        settings
      }
    })
  }, [settings, betslipState.id])

  return (
    <BetslipContext.Provider value={betslipState}>
      {children}
    </BetslipContext.Provider>
  )
}

const emptyEditBetslipState = {
  active: true,
  fullfited: true,
  suspended: false,
  loading: false,
  initialized: false,
  confirming: false,
  betItems: [],
  betTypes: [],
  reports: [],
  errors: {},
  outcomesErrors: {}
}

const createBetslipInitialState = (options) => {
  const {
    id = 'edit',
    bet,
    settings,
    ...restOptions
  } = options

  const initialState = {
    ...emptyEditBetslipState,
    id,
    betId: bet.betId,
    loading: false,
    initialized: true,
    settings,

    ...restOptions
  }

  // Validating provided bet
  if (isEmpty(bet) || isEmpty(bet.outcomes)) {
    return initialState
  }

  // Extracting bets
  const rawBetItems = extractBetsFromBetDtoOutcomes(bet.outcomes)

  // Populating bets with requestIds
  initialState.betItems = rawBetItems.map(bet => {
    bet.requestId = bet.requestId || getIntUID()

    return bet
  })

  // Generating available bet types
  initialState.betTypes = BetManager.betTypesCalculator.getAvailableBetTypes(
    initialState
  )

  return initialState
}

export function createEditBetslipState (options) {
  const [state, dispatch] = React.useReducer(
    betslipReducer,
    options,
    createBetslipInitialState
  )

  /*
    Initializing
    - Register betslip dispatcher in bus
    - Resolving stored bet items
  */
  React.useEffect(
    () => {
      const betslipNamespace = `betslip:${state.id}`
      const handleBetslipDispatch = action => dispatch(action)
      // Register dispatcher
      Bus.on(betslipNamespace, handleBetslipDispatch)

      return () => {
        Bus.off(betslipNamespace, handleBetslipDispatch)
      }
    },
    []
  )

  useBetsOddsHighlight(state.betItems, ODDS_HIGHLIGHTED_STATUS.EDITING)

  return state
}
